import { Box, BoxProps, ColorOptions, Icon, ModBox, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { useStores } from '../../../data/store'
import { StatusIndicator } from '../../StatusIndicator'
interface BusinessHierarchyItemProps {
  data: any
  index: number
  onViewEntities: (data: any) => void
  childList: any[]
  entityLevel: number
}

const BusinessHierarchyItem: FC<BusinessHierarchyItemProps> = (props: BusinessHierarchyItemProps) => {
  const { getLovsDescriptionFromKeyValue } = useStores((store) => ({
    getLovsDescriptionFromKeyValue: store.getLovsDescriptionFromKeyValue,
  }))
  console.log('BusinessHierarchyItem: props: ', props)
  const handleViewDetails = () => {}
  return (
    <Box>
      <ModBox
        show={props?.index > 0}
        w={13}
        h={props?.data?.type === 'L1' ? 30 : 52}
        borderLeftWidth={1}
        borderBottomWidth={1}
        marginLeft={props?.index > 0 ? (props?.data?.type === 'L1' ? 7 * props?.index : 11 * props?.index) : 0}
        borderLeftColor={'BORDER_COLOR'}
        borderBottomColor={'BORDER_COLOR'}
        borderStyle={props?.entityLevel > 2 && props?.data?.type === 'Parent' ? 'dashed' : 'solid'}
      />
      <ModBox
        show={props?.data?.type !== 'L1'}
        marginLeft={props?.index > 0 ? 15 * props?.index : 0}
        borderWidth={1}
        borderColor={'BORDER_COLOR'}
        borderRadius={4}
        w={props?.index > 0 ? `${99 - props?.index}%` : '99.3%'}
        h={70}
        marginTop={props?.index > 0 ? -30 : 0}
        flexDirection={'row'}>
        <Box {...styles(props?.data?.type).leftBox} justifyContent={'flex-start'}>
          <Text
            textAlign="center"
            title={props?.data?.type?.toUpperCase()}
            color={
              (props?.data?.type === 'Group'
                ? '#C42B54'
                : props?.data?.type === 'Subgroup'
                ? '#66247A'
                : props?.data?.type === 'Parent'
                ? 'YELLOW'
                : '#24707A') as ColorOptions
            }
            fontSize={12}
            fontFamily={'jiotype-medium'}
          />
        </Box>
        <Box padding={16} w={'78%'}>
          <Box direction="row">
            <Text title={props?.data?.name} color={'BLACK_21'} fontSize={14} fontFamily={'jiotype-bold'} />
            <Box marginLeft={16} marginTop={-2}>
              <StatusIndicator
                type={getLovsDescriptionFromKeyValue('Status', props?.data?.status)?.toString()?.toLowerCase()}
              />
            </Box>
          </Box>
          <Box direction="row" marginTop={4}>
            <ModBox
              direction="row"
              show={props?.data?.source === 'MAS' && props?.data?.type !== 'Group' && props?.data?.type !== 'Subgroup'}>
              <Text title={'MAS ID : '} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
              <Text title={props?.data?.masId} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-medium'} />
            </ModBox>
            <Box direction="row" marginLeft={16}>
              <Text
                title={
                  props?.data?.type === 'Group'
                    ? 'Group ID : '
                    : props?.data?.type === 'Subgroup'
                    ? 'SubGroup ID : '
                    : props?.data?.type === 'Parent'
                    ? 'Parent ID : '
                    : 'Entity ID : '
                }
                color={'BLACK_75'}
                fontSize={12}
                fontFamily={'jiotype-medium'}
              />
              <Text title={props?.data?.id ?? 'NA'} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-medium'} />
            </Box>
            <ModBox show={props?.data?.level?.length > 0} direction="row" marginLeft={16}>
              <Text title={'Level : '} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
              <Text
                title={props?.data?.level ?? 'N/A'}
                color={'BLACK_21'}
                fontSize={12}
                fontFamily={'jiotype-medium'}
              />
            </ModBox>
          </Box>
        </Box>
        <ModBox
          show={false} //props?.data?.type !== 'Entity'
          direction="row"
          alignItems={'center'}
          justifyContent={'flex-end'}
          underlayColor={'BACKGROUND_LIGHT'}
          onPress={handleViewDetails}>
          <Text title={'View Details'} color={'PRIMARY'} fontSize={12} fontFamily={'jiotype-medium'} />
          <Icon size={16} id={'ARROW_RIGHT'} color={'PRIMARY'} />
        </ModBox>
      </ModBox>
      <ModBox>
        <ModBox
          show={props?.data?.type === 'Entity' && props?.childList?.length > 0}
          w={13}
          h={40}
          borderLeftWidth={1}
          borderBottomWidth={1}
          marginLeft={props?.index > 0 ? 17 * props?.index : 11}
          borderLeftColor={'BORDER_COLOR'}
          borderBottomColor={'BORDER_COLOR'}
        />
        <ModBox
          {...styles(props?.data?.type).viewL1Box}
          show={props?.data?.type === 'Entity' && props?.childList?.length > 0}
          marginLeft={props?.index > 0 ? 21 * props?.index : 11}
          onPress={() => props?.onViewEntities(props?.data)}
          underlayColor={'BACKGROUND_LIGHT'}>
          <Text
            title={`View L${props?.entityLevel + 1} Entities`}
            color={'PRIMARY'}
            fontSize={12}
            fontFamily={'jiotype-medium'}
          />
          <Icon color={'PRIMARY'} id={'ARROW_RIGHT'} size={16} />
        </ModBox>
      </ModBox>
    </Box>
  )
}

export { BusinessHierarchyItem }

const styles = (type: string) => {
  return {
    leftBox: {
      backgroundColor: (type === 'Group'
        ? '#EBCAD3'
        : type === 'Subgroup'
        ? '#E3D9E7'
        : type === 'Parent'
        ? '#553223'
        : '#9bb5b3') as ColorOptions,
      w: type === 'Group' ? '11%' : type === 'Subgroup' ? '12%' : '13%',
      h: 68,
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 24,
      borderTopLeftRadius: 3,
      borderBottomLeftRadius: 3,
    } as BoxProps,
    viewL1Box: {
      w: 142,
      h: 32,
      borderWidth: 1,
      backgroundColor: 'WHITE',
      borderColor: 'BORDER_COLOR',
      borderRadius: 4,
      direction: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: -16,
    } as BoxProps,
  }
}
